import { type ReactNode } from 'react'

import { LinkOutbound, LinkRoute } from '@/components/common/Link'
import { buildRoute } from '@/utils/routeUtil'

type Props = {
  children: ReactNode
  className?: string
  disabled?: boolean
  newTab?: boolean
  slug?: string
}

export const ArticleAuthorLink = ({ children, className, disabled, newTab, slug: authorSlug }: Props) => {
  const href = authorSlug ? buildRoute({ authorSlug, section: 'articlesAuthor' }) : undefined

  const Element = newTab ? LinkOutbound : LinkRoute

  return !disabled && !!href ? (
    <Element className={className} href={href}>
      {children}
    </Element>
  ) : (
    <span className={className}>{children}</span>
  )
}
